import { render, staticRenderFns } from "./PracticeTopic.vue?vue&type=template&id=0de5a95a&scoped=true&"
import script from "./PracticeTopic.vue?vue&type=script&lang=js&"
export * from "./PracticeTopic.vue?vue&type=script&lang=js&"
import style0 from "./PracticeTopic.vue?vue&type=style&index=0&id=0de5a95a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de5a95a",
  null
  
)

export default component.exports